import { useTranslation } from "@/hooks/useSafeTranslation";
import { cn, toDisplayString, toSafeReactNode } from "@/lib/utils";

const PLAN_STYLES: Record<string, string> = {
  free: "bg-surface-2 text-text-muted border-border",
  starter: "bg-teal-500/20 text-teal-500 border-teal-500/40",
  pro: "bg-green-500/20 text-green-400 border-green-500/40",
  team: "bg-amber-500/20 text-amber-500 border-amber-500/40",
};

type PlanId = "free" | "starter" | "pro" | "team" | string;

export interface PlanBadgeProps {
  planId: PlanId;
  className?: string;
}

function toPlanIdString(v: unknown): string {
  return toDisplayString(v, "free");
}

export function PlanBadge({ planId, className }: PlanBadgeProps) {
  const { t } = useTranslation("billing");
  const key = toPlanIdString(planId).toLowerCase();
  const style = PLAN_STYLES[key] ?? PLAN_STYLES.free;
  const labelKey = key as "free" | "starter" | "pro" | "team";
  const label = ["free", "starter", "pro", "team"].includes(key)
    ? toDisplayString(t(labelKey))
    : key.charAt(0).toUpperCase() + key.slice(1);
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium",
        style,
        className
      )}
    >
      {toSafeReactNode(label)}
    </span>
  );
}
